import type { AppRouteRecordRaw } from '@/types/router'
import { ROUTE_NAMES } from '@/types/router'

// 海报相关路由配置
export const posterRoutes: AppRouteRecordRaw[] = [
  {
    path: '/deck-poster',
    name: ROUTE_NAMES.DECK_POSTER,
    component: () => import('@/views/poster/DeckPoster.vue'),
    meta: {
      titleKey: 'routeTitle.deckPoster',
      keepAlive: false,
    },
  },
  {
    path: '/pack-poster',
    name: ROUTE_NAMES.PACK_POSTER,
    component: () => import('@/views/poster/PackPoster.vue'),
    meta: {
      titleKey: 'routeTitle.packPoster',
      keepAlive: false,
    },
  },
  {
    path: '/wish-poster',
    name: ROUTE_NAMES.WISH_POSTER,
    component: () => import('@/views/poster/WishPoster.vue'),
    meta: {
      titleKey: 'routeTitle.wishPoster',
      keepAlive: false,
    },
  },
  {
    path: '/shop-poster',
    name: ROUTE_NAMES.SHOP_POSTER,
    component: () => import('@/views/poster/ShopPoster.vue'),
    meta: {
      titleKey: 'routeTitle.shopPoster',
      keepAlive: false,
    },
  },
  {
    path: '/ai-news-poster',
    name: ROUTE_NAMES.AI_NEWS_POSTER,
    component: () => import('@/views/poster/AiNewsPoster.vue'),
    meta: {
      titleKey: 'routeTitle.aiNews',
      keepAlive: false,
    },
  },
  {
    path: '/dynamic-poster',
    name: ROUTE_NAMES.DYNAMIC_POSTER,
    component: () => import('@/views/poster/DynamicPoster.vue'),
    meta: {
      titleKey: 'routeTitle.dynamicPoster',
      keepAlive: false,
    },
  },
  {
    path: '/ai-deck-poster',
    name: ROUTE_NAMES.AI_DECK_POSTER,
    component: () => import('@/views/poster/AIDeckPoster.vue'),
    meta: {
      titleKey: 'routeTitle.aiDeck',
      keepAlive: false,
    },
  },
  {
    path: '/card-album-poster',
    name: ROUTE_NAMES.CARD_ALBUM_POSTER,
    component: () => import('@/views/poster/CardAlbumPoster.vue'),
    meta: {
      titleKey: 'routeTitle.cardAlbum',
      keepAlive: false,
    },
  },
  {
    path: '/card-poster',
    name: ROUTE_NAMES.CARD_POSTER,
    component: () => import('@/views/poster/CardPoster.vue'),
    meta: {
      titleKey: 'routeTitle.cardPoster',
      keepAlive: false,
    },
  },
  {
    path: '/user-poster',
    name: ROUTE_NAMES.USER_POSTER,
    component: () => import('@/views/poster/UserPoster.vue'),
    meta: {
      titleKey: 'routeTitle.userPoster',
      keepAlive: false,
    },
  },
  {
    path: '/auction-poster',
    name: ROUTE_NAMES.AUCTION_POSTER,
    component: () => import('@/views/poster/AuctionPoster.vue'),
    meta: {
      titleKey: 'routeTitle.auctionPoster',
      keepAlive: false,
    },
  },
] 